import * as dressage from './actions';
import {DressageState, JsonDressageProtocol} from './types';
import {ActionType, getType} from 'typesafe-actions';
import {Middleware} from 'redux';
import environment from "../environment";

export const fetchDressageItemMiddleware: Middleware<{}, DressageState> = ({getState}) => next => async (action: ActionType<typeof dressage>) => {
  next(action);

  if (action.type != getType(dressage.updateDressageProtocol)) {
    return;
  }

  next(dressage.fetchDressageProtocol.request());
  try {
    const response = await fetch(`${environment.getHost()}/api/dressageprotocols/v1/${action.payload}`);
    const json: JsonDressageProtocol = await response.json();
    next(dressage.fetchDressageProtocol.success(json));
  } catch (e) {
    next(dressage.fetchDressageProtocol.failure(e));
  }
};
